export const deTranslations = {
  navbar: {
    about: 'Über mich',
    contact: 'Kontakt',
    language: 'Sprache'
  },
  contactPage: {
    title: 'Kontakt',
    subtitle: 'Bitte zögern Sie nicht, mich zu kontaktieren, indem Sie das Formular ausfüllen.',
    nameLabel: 'Name',
    emailLabel: 'E-Mail',
    subjectLabel: 'Betreff',
    messageLabel: 'Nachricht',
    required: '*',
    namePlaceholder: 'Ihr Name',
    emailPlaceholder: 'deine.email@beispiel.de',
    subjectPlaceholder: 'Betreff',
    messagePlaceholder: 'Ihre Nachricht...',
    sendButton: 'Nachricht senden',
    sendingButton: 'Sende...',
    errorEmpty: 'Bitte füllen Sie alle Felder aus.',
    errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    successMsg: 'Nachricht erfolgreich gesendet!',
    failMsg: 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.'
  },
  footer: {
    aboutMe: 'Über mich',
    contact: 'Kontakt',
    language: 'Sprache'
  },
  footerInfo: {
    legal: 'Rechtliches',
    privacy: 'Datenschutz',
    copyright: '© 2025 Gianni Carozza. Alle Rechte vorbehalten.'
  },
  homePage: {
    firstLine: '"Hallo Welt", ich bin ',
    secondLine: 'Gianni Carozza',
    description: 'leidenschaftlicher Softwareentwickler.\nWo Vorstellung die Innovation beflügelt.',
    location: '📍 München, Deutschland',
    universityProjects: 'Universitätsprojekte',
    universitySubtitle: 'Projekte, die im Rahmen meines Studiums entstanden sind',
    personalProjects: 'Persönliche Projekte',
    personalSubtitle: 'Weil ich es liebe, zu kreieren',
    cta: 'Lass uns Ideen zum Leben erwecken!',
    contact: 'Kontaktiere mich'
  },
  uniProjectsPage: {
    title: 'Universitätsprojekte',
    lines: [
      'Hier werden Ideen zur Realität.',
      'Mit Leidenschaft und einem Auge für Details,',
      'entwickle ich Apps, die Nutzer inspirieren',
      'und echten Mehrwert schaffen.'
    ],
    placeholderLabel: 'Projektname',
    project1: "Projektmodul Web",
    project2: "Generative Design x AI",
    project3: "Mobile Anwendungen",
    project4: "Personal Health x AI",
  },
  personalProjectsPage: {
    title: 'Eigene Projekte',
    lines: [
      'Hier werden Ideen zur Realität.',
      'Mit Leidenschaft und einem Auge für Details,',
      'entwickle ich Apps, die Nutzer inspirieren',
      'und echten Mehrwert schaffen.'
    ],
    placeholderLabel: 'Projektname',
    project1: "Circa Quiz",
    project2: "Paper Soccer",
    project3: "Dot 2D",
  },
  generativeDesignXAIPage: {
    heroTitle: 'Wetter Fingerprint',
    heroSubtitle: 'Generatives Gestaltung eines Klimadaten-Projekts',
    heroCodedIn: 'Programmiert in Java',
    summaryTitle: 'Zusammenfassung',
    conceptTitle: 'Konzept & Technischer Ansatz',
    designTitle: 'Designprozess & Erkenntnisse',
    moreThanCities: 'Mehr als 100 Städte',
    generatorTitle: '2D & 3D Modelle Generator',
    modelButton: '3D-Modell erstellen',
    howFingerprintTitle: 'Wie das Fingerabdruckmuster erstellt wird',
    leggobrickTitle: 'Wie der LEGGO Brick erstellt wird',
    modelCarouselTitle: '3D Modelle Karussell',
    
    // Tab contents
    summaryContent: [
      "Ein kreatives Datenvisualisierungsprojekt, das Wetterinformationen in einzigartige visuelle \"Fingerabdrücke\" umwandelt, unter Verwendung generativer Designtechniken.",
      "Durch die Umwandlung von meteorologischen Daten verschiedener Städte in grafische Darstellungen erkundet das Projekt die Schnittstelle von Daten, Design und Technologie."
    ],
    
    conceptContent: {
      parametersIntro: "Das Projekt verwendet drei wichtige Wetterparameter, um eine unverwechselbare visuelle Darstellung zu schaffen:",
      parameters: [
        "Rot: Temperatur (°C)",
        "Blau: Luftfeuchtigkeit (%)",
        "Weiß: Windgeschwindigkeit (km/h)"
      ],
      innovationsTitle: "Wichtige Innovationen",
      innovations: [
        "Nutzung von Perlin-Rauschen für agentenbasierte Mustergenerierung",
        "Implementierung eines farbkodierten Systems zur Darstellung von Wetterintensitäten",
        "Entwicklung einer Methode zur Erstellung 3D-ähnlicher Visualisierungen"
      ],
      sliderLabels: {
        temperature: "Temperatur:",
        humidity: "Luftfeuchtigkeit:",
        windSpeed: "Windgeschwindigkeit:"
      }
    },
    
    designContent: {
      processTitle: "Prozess",
      processList: [
        "Generieren einzigartiger Wetter-Fingerabdruck-Muster",
        "Anpassen des Musters basierend auf ortsspezifischen Wetterdaten",
        "Erstellen einer Visualisierung mit variierenden Balkenhöhen und -farben",
        "Zusammenführen der Elemente zu einem kohärenten \"LEGGO Brick\"-Design"
      ],
      learningsTitle: "Erkenntnisse",
      learningsList: [
        "Erforschung von Möglichkeiten, Wetterdaten ansprechender zu gestalten",
        "Experimentieren mit verschiedenen Visualisierungstechniken",
        "Entwicklung einer Methode zur Komprimierung komplexer Daten in intuitive Grafiken"
      ]
    },
    
    steps: {
      fingerprint: {
        step1Title: 'Schritt 1',
        step1List: [
          'Agenten bewegen sich durch das Bild mithilfe von Perlin-Rauschen',
          'Agenten zeichnen eine Spur hinter sich'
        ],
        step2Title: 'Schritt 2',
        step2List: [
          'Bewegung der Agenten wird in einem zufälligen Bereich in der Mitte des Bildschirms mit Curl-Effekt zentriert',
          'Mehr Abstand zwischen den Agenten eingeführt'
        ],
        step3Title: 'Schritt 3',
        step3List: [
          'Farblegend zur Darstellung der Wetterintensität implementiert'
        ],
        step4Title: 'Schritt 4',
        step4List: [
          'Realwelt-Wetterintensität färbt den Fingerabdruck'
        ]
      },
      leggobrick: {
        step1Title: 'Schritt 1',
        step1List: [
          'Balken repräsentieren verschiedene Agentenbereiche',
          'Balkenfarbe/-länge wird durch die Wetterintensitäten bestimmt'
        ],
        step2Title: 'Schritt 2',
        step2List: [
          'Kameraperspektive wird angepasst'
        ],
        step3Title: 'Schritt 3',
        step3List: [
          'Balken werden zu einem Objekt zusammengeführt'
        ],
        step4Title: 'Schritt 4',
        step4List: [
          'Gemeinsame Basis für Balken',
          'Gemeinsame Kante für Balken',
          'Brick-Basis erstellt'
        ],
        step5Title: 'Schritt 5',
        step5List: [
          'Anzahl der Balken skaliert',
          'Höhe normalisiert',
          'Abgerundete Kanten',
          'LEGGO Brick erstellt'
        ]
      }
    },
    leggobrickStepsTitle: 'Wie der LEGGO Brick erstellt wird',
    fingerprintStepsTitle: 'Wie das Fingerabdruckmuster erstellt wird',
    inspectorModeOn: 'Inspektormodus: AN (Drücken Sie "q" zum Beenden)',
    inspectorModeOff: 'Inspektormodus: AUS',
    footerLinks: {
      aboutMe: 'Über mich',
      contact: 'Kontakt',
      language: 'Sprache'
    },
    footerInfo: {
      legal: 'Rechtliches',
      privacy: 'Datenschutz',
      copyright: '© 2025 Gianni Carozza. Alle Rechte vorbehalten.'
    }
  },
  aboutPage: {
    stepsData: [
      {
        bigHeading: 'Willkommen!',
        paragraphs: [
          "Hallo! Ich bin Gianni Carozza, ein leidenschaftlicher Entwickler und Designer, der sich auf die Erstellung ansprechender und benutzerfreundlicher digitaler Erlebnisse spezialisiert hat. Mit einem starken Hintergrund in Computational Thinking, nutzerzentriertem Design und mobilen Anwendungen strebe ich danach, Kreativität mit Funktionalität in jedem Projekt, das ich übernehme, zu verbinden.",
          "Meine Reise im Design und in der Entwicklung hat mich mit einem vielfältigen Fähigkeiten ausgestattet, die es mir ermöglichen, komplexe Herausforderungen anzugehen und innovative Lösungen zu liefern. Ob es darum geht, intuitive Schnittstellen zu gestalten, robuste Webanwendungen zu entwickeln oder die Potenziale künstlicher Intelligenz im Design zu erkunden – ich bin stets bestrebt, zu lernen und zu wachsen."
        ],
        skills: null,
      },
      {
        bigHeading: 'Skills',
        paragraphs: [],
        skills: [
          'HTML', 
          'CSS', 
          'JavaScript', 
          'Angular', 
          'React', 
          'TypeScript',
          'React Native', 
          'Python', 
          'SCRUM', 
          'Git', 
          'Figma', 
          'TouchDesigner'
        ],
      },
      {
        bigHeading: 'Ausbildung',
        paragraphs: [
          "Derzeit studiere ich Informatik und Design an der Hochschule München, wo ich tiefer in die Schnittstelle von Technologie und Ästhetik eintauche, um bedeutungsvolle und benutzerfreundliche digitale Produkte zu schaffen."
        ],
        skills: null,
      },
      {
        bigHeading: 'Erfahrung',
        paragraphs: [
          "Im Laufe der Jahre habe ich verschiedene Technologien eingesetzt, um Projekte zu entwickeln, die entweder eine Vision oder ihre Mission zum Leben erwecken. Mein Fachwissen erstreckt sich über verschiedene Bereiche, darunter Web- und App-Entwicklung, Web- und App-Design, Service-Design sowie Optimierung der Benutzererfahrung."
        ],
        skills: null,
      },
    ]
  },
  privacyPage: {
    title: 'Datenschutzerklärung',
    content: `**Datenschutzerklärung**

Ihre Privatsphäre ist wichtig. Diese Datenschutzerklärung erklärt, wie mit Ihren persönlichen Informationen umgegangen wird.

**Informationserfassung**

Prinzipiell werden nur Informationen erfasst, die Sie uns direkt bereitstellen, wie zum Beispiel beim Erstellen eines Kontos, Ausfüllen eines Formulars oder bei einer Kontaktaufnahme.

**Verwendung der Informationen**

Die Informationen werden verwendet, um die Dienstleistungen bereitzustellen, aufrechtzuerhalten und zu verbessern sowie um mit Ihnen zu kommunizieren.

**Datensicherheit**

Es werden angemessene Sicherheitsmaßnahmen eingesetzt, um Ihre Daten zu schützen.

**Ihre Rechte**

Unter der DSGVO haben Sie das Recht auf Auskunft, Berichtigung oder Löschung Ihrer persönlichen Daten. Sie können auch die Einschränkung oder Widerspruch gegen bestimmte Datenverarbeitungen geltend machen.

**Änderungen dieser Erklärung**

Diese Datenschutzerklärung kann von Zeit zu Zeit aktualisiert werden. Über Änderungen werden sie informiert, indem wir die neue Erklärung auf dieser Seite veröffentlichen.

**Kontaktieren Sie uns**

Wenn Sie Fragen zu dieser Datenschutzerklärung haben, kontaktieren Sie mich.`
  },
  legalPage: {
    title: 'Impressum',
    content: `**Impressum**

**Angaben gemäß § 5 TMG:**

**Kontakt:**

E-Mail: agianniproject@gmail.com  

**Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:**

Gianni Carozza  
  
**Haftungsausschluss:**

**Haftung für Inhalte**

Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

**Haftung für Links**

Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.

**Urheberrecht**

Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.

**Datenschutz**

Unsere Datenschutzerklärung finden Sie unter Footer > Datenschutz.`
  },

  /* -------------------- NEW: CIRCA PAGE STRINGS (DE) -------------------- */
  circaPage: {
    heroTitle: 'Ein fesselndes Quiz-Erlebnis: <br /> Jederzeit, überall',
    tabSummary: 'Zusammenfassung',
    tabConcept: 'Technologie & Design',
    tabDevelopment: 'Entwicklungsprozess & Erkenntnisse',

    summaryTexts: [
      `CIRCA ist eine plattformübergreifende Quiz-App, entwickelt mit React Native, die Menschen überall zu spannenden Quiz-Sessions zusammenbringt.`,
      `Die Verbindung aus schlankem Design und einer intuitiven Benutzeroberfläche demonstriert meinen Fokus auf Nutzerbindung, nahtlose Leistung und flexible Spieloptionen für eine Vielzahl von Zielgruppen.`
    ],
    conceptTexts: [
      `CIRCA nutzt React Native, um eine Codebasis sowohl für iOS- als auch Android-Geräte bereitzustellen. Diese Herangehensweise vereinfacht die Entwicklung und sorgt für Konsistenz über verschiedene Plattformen hinweg. Das Design der Anwendung konzentriert sich auf eine schlanke Struktur für schnelle Ladezeiten und anpassbare, reaktionsschnelle Layouts, die ein flüssiges Benutzererlebnis gewährleisten.`,
      `Darüber hinaus verwendet CIRCA ein dynamisches Datenmanagement und lokalem Speicher. Damit kann die App Daten in Echtzeit verarbeiten und aktualisieren, während wichtige Informationen gleichzeitig direkt auf dem Gerät gespeichert werden. CIRCA bleibt somit auch ohne Internetverbindung voll funktionsfähig und bietet stets ein zuverlässiges und spannendes interaktives Erlebnis – unabhängig von der Konnektivität.`
    ],
    developmentTexts: [
      `Die Entwicklung von CIRCA mit React Native bot zahlreiche Möglichkeiten, meine Kenntnisse in der plattformübergreifenden App-Entwicklung zu vertiefen. Ich legte besonderen Wert auf eine ansprechende und benutzerfreundliche Oberfläche, indem ich die komponentenbasierte Architektur von React Native nutzte. Dank responsiver Designprinzipien und einer Optimierung der Interaktionspunkte entstand ein flüssiges und intuitives Nutzererlebnis für eine breitgefächerte Zielgruppe.`,
      `Im Verlauf der Entwicklung galt es, verschiedene Herausforderungen zu meistern, etwa die Verwaltung komplexer Zustände auf mehreren Bildschirmen und die Sicherstellung einer Echtzeit-Datensynchronisierung. Diese Erfahrungen schärften mein Bewusstsein für effektive Debugging-Techniken in einer Umgebungen mit mehreren Endgeräten. Darüber hinaus erlangte ich durch die Performance-Optimierung und Verbesserung der Struktur der App wertvolle Erkenntnisse im Hinblick auf effiziente Ressourcennutzung und hohe Codequalität – eine solide Grundlage für zukünftige Mobile-Projekte.`
    ],

    // New translations for full page support
    userFlowTitle: "User Flow",
    userFlowDesc: "CIRCA wurde mit extrem einfachen und schnellen Benutzerfluss entwickelt, der Spieler mit nur wenigen Fingertipps ins Spiel bringt. Alles ist bewusst einfach und intuitiv gestaltet, sodass Gruppen sofort mit der Beantwortung von Fragen beginnen und ohne unnötige Schritte oder Unterbrechungen Spaß haben können.",
    flowNodes: {
      settings: "Einstellungen",
      home: "Home screen",
      language: "Sprache",
      playerCount: "Spieleranzahl",
      timer: "Timereinstellung",
      categories: "Kategorienauswahl",
      playerCards: "Spielerkarten",
      winner: "Gewinnerpodium"
    },
    
    typoTitle: "Typography & Colors",
    fontName: "Urbanist Bold",
    bodyText: "Body Text",
    
    processTitle: "Design Process",
    processIntro: "Der Designprozess von CIRCA konzentrierte sich darauf, ein Spiel zu entwickeln, das in wenigen Sekunden verstanden wird und sofort Spaß macht. Jede Phase – von der Ideenfindung bis zum finalen Interface – wurde darauf optimiert, Interaktionen so leicht und schnell wie möglich zu gestalten. Durch kontinuierliches Prototyping und Testen entstand ein Erlebnis, das Gruppen ohne Erklärungen ins Spiel bringt.",
    processCards: [
      {
        title: "Understanding & Concept Definition",
        subtitle: "Wie entsteht ein schnelles, soziales Spiel?",
        text: "Für CIRCA begann alles mit der Frage, wie man ein Quizspiel entwickelt, das <strong>sofort verstanden wird</strong>, perfekt für Gruppen funktioniert und ohne Erklärungen Spaß macht.<br /><br />Wir definierten die Spielmechanik, analysierten typische Gruppensituationen (Partys, Reisen, WG-Abende) und legten klare Ziele fest: <strong>Schnelligkeit, Einfachheit, Humor und ein friktionsloser Ablauf.</strong>",
        tags: ["identifying group use cases", "core interaction", "core values", "concept sketching"]
      },
      {
        title: "Research & Analysis",
        subtitle: "Wie macht man ein Quiz, das sich anders anfühlt?",
        text: "Wir untersuchten bestehende Quiz- und Partyspiele, identifizierten typische Pain Points (zu viel Text, zu kompliziert, zu langsam, UI überladen) und validierten durch Tests mit Freunden, welche Art von Fragen und Abläufen am schnellsten funktionieren.<br />Das Ziel: <strong>Zero friction – maximaler Fun-Flow.</strong>",
        tags: ["wireframing", "Fragekategorien testen", "competitor analysis", "user flow optimieren"]
      },
      {
        title: "Design & Development",
        subtitle: "Vom Konzept zum lebendigen Erlebnis.",
        text: "Im nächsten Schritt entwickelten wir ein UI-Design, das frisch, freundlich und sofort verständlich wirkt.<br />Der Fokus lag darauf, dass sich jeder Screen in <strong>unter einer Sekunde</strong> erfassen lässt – damit die Gruppe im Flow bleibt.",
        tags: ["UX/UI Design", "Development", "prototyping", "Visual design system", "App Store preparation", "iterative testing"]
      }
    ],

    mockupsTitle: "Mockups",
    mockupsIntro: "Die Mockups zeigen, wie unkompliziert Spieler durch CIRCA geführt werden.",
    
    outroText: "Manchmal gewinnt Wissen,<br/>manchmal Intuition – aber<br/>Spaß gewinnt immer.",

    appStoreAlt: 'Jetzt im App Store verfügbar',

    categoriesHeader: '5 Kategorien',
    categoriesIntro:
      `Erlebe eine breite Palette von Quizfragen, die von alltäglichen Kuriositäten bis zu faszinierenden Fakten über unsere Welt reichen. Jede Kategorie verfügt über mehr als 100 sorgfältig ausgewählte Fragen und bietet somit die perfekte Mischung aus Spaß, Herausforderung und Wissensvermittlung für Quiz-Fans aller Niveaus.`,

    categories: [
      {
        name: 'Allgemeinwissen',
        icon: 'general.png',
        description: `Stimmen Sie Ihr Gehirn mit einer breiten Auswahl an Alltagsthemen ein – ideal, um jede Quiz-Runde in Schwung zu bringen und alle zu begeistern.`
      },
      {
        name: 'Geografie',
        icon: 'geography.png',
        description: `Starten Sie eine Weltreise vom Sofa aus: testen Sie Ihr Wissen über Städte, Länder und berühmte Wahrzeichen aller Kontinente.`
      },
      {
        name: 'Mathematik',
        icon: 'mathematics.png',
        description: `Fordern Sie Ihre Logik- und Problemlösungsfähigkeiten mit Denksportaufgaben und Berechnungen heraus, von grundlegenden Operationen bis hin zu kniffligen Rätseln.`
      },
      {
        name: 'Natur',
        icon: 'nature.png',
        description: `Tauchen Sie ein in die Wunder unserer Erde, ihrer Tierwelt, Lebensräume und Ökosysteme – vom Meeresgrund bis zu Berggipfeln und darüber hinaus.`
      },
      {
        name: 'Wissenschaft',
        icon: 'science.png',
        description: `Erkunden Sie die Faszination von Physik, Chemie, Biologie und mehr – erweitern Sie Ihre Grenzen dessen, was Sie über unsere Welt wissen.`
      }
    ],

    repeatedBoxes: [
      {
        title: 'Vielfältige Kategorien für alle',
        content:
          `Ob routinierter Quiz-Profi oder neugieriger Neuling – hier finden Sie garantiert ein Thema, das Ihr Interesse weckt. Entdecken Sie neue Gebiete, beleben Sie alte Favoriten wieder und genießen Sie die Vielfalt, die CIRCA in jede Spieleabend-Runde bringt.`
      },
      {
        title: 'Anpassbares Erlebnis',
        content:
          `Passen Sie jede Quiz-Runde an die individuellen Vorlieben Ihrer Gruppe an – wählen Sie die Anzahl der Runden, Zeitlimits oder geben Sie den Spielernamen eine persönliche Note. Gestalten Sie das Spiel so entspannt oder herausfordernd, wie Sie möchten.`
      },
      {
        title: 'Mehrsprachiges Gameplay',
        content:
          `Überwinden Sie Sprachbarrieren und laden Sie jeden zum Mitmachen ein – CIRCA unterstützt sowohl Englisch als auch Deutsch. Perfekt, um inklusive Quiz-Sessions zu veranstalten und nebenbei die eigenen Sprachkenntnisse zu verbessern.`
      }
    ],

    peopleImgAlt1: 'Menschen, die die App benutzen (links)',
    peopleImgAlt2: 'Menschen, die die App benutzen (rechts)'
  },
  /* -------------------- NEW: PAPER SOCCER PAGE STRINGS (DE) -------------------- */
  paperSoccerPage: {
    heroTitle: 'Paper Soccer',
    heroSubtitle: 'Ein einfaches, aber fesselndes rundenbasiertes Strategiespiel',
    heroImageAlt: 'Paper Soccer Spiel auf dem Mobiltelefon',
    techBadge: 'Entwickelt mit React Native',
    
    tabOverview: 'Übersicht',
    tabHowToPlay: 'Spielanleitung',
    tabRules: 'Regeln',
    
    overviewTitle: 'Spielübersicht',
    overviewDescription: 'Paper Soccer ist ein einfaches React Native-Spiel mit einer Rasteroberfläche, das zwei Spielern ermöglicht, abwechselnd Felder auszuwählen und Pfade zwischen ihnen zu zeichnen. Das Spiel kombiniert Strategie und schnelles Denken in einer digitalen Adaption des klassischen Papier-und-Stift-Spiels.',
    
    featuresTitle: 'Funktionen',
    featuresList: [
      'Zwei Hauptbildschirme: Startbildschirm und Spielbildschirm',
      'Rasterbasiertes Gameplay mit intuitiver Steuerung',
      'Spieleranpassung mit Farbauswahl',
      'Bearbeitbare Spielernamen',
      'Rückgängig-Funktion',
      'Klare, minimalistische Benutzeroberfläche'
    ],
    
    customizationTitle: 'Anpassungsmöglichkeiten',
    customizationDescription: 'Spieler können ihr Erlebnis durch die Auswahl von Farben und die Bearbeitung ihrer Namen über eine einfache Texteingabe anpassen.',
    
    howToPlayTitle: 'Spielanleitung',
    howToPlaySteps: [
      'Starte die App und navigiere zum Startbildschirm',
      'Drücke "Start", um ein neues Spiel zu beginnen',
      'Passe bei Bedarf Spielernamen und -farben an',
      'Spieler wählen abwechselnd benachbarte Felder aus, um Pfade zu bilden',
      'Verwende die Rückgängig-Taste, um den letzten Zug rückgängig zu machen',
      'Der erste Spieler, der sein Ziel erreicht, gewinnt'
    ],
    gameplayImageAlt: 'Paper Soccer Gameplay-Demonstration',
    
    rulesTitle: 'Spielregeln',
    rulesCategories: [
      {
        title: 'Feldauswahl',
        rules: [
          'Spieler können nur Felder auswählen, die dem zuletzt gewählten Feld benachbart sind',
          'Nachbarschaft umfasst horizontale, vertikale und diagonale Nachbarn',
          'Zielfelder befinden sich in der Mitte oben und unten im Raster',
          'Diagonale Züge sind nur in den Ecken erlaubt'
        ]
      },
      {
        title: 'Pfadbildung',
        rules: [
          'Spieler können denselben Pfad nicht zweimal gehen',
          'Sobald ein Pfad zwischen Zellen genommen wurde, kann er nicht wiederverwendet werden',
          'Wenn ein Spieler ein Feld auswählt, das bereits ausgewählt wurde oder ein Randfeld ist, erhält er einen zusätzlichen Zug'
        ]
      },
      {
        title: 'Gewinnbedingungen',
        rules: [
          'Das Ziel ist es, vom Startpunkt in der Mitte zum eigenen Zielfeld zu navigieren',
          'Ein Spieler gewinnt, indem er mit einem gültigen Zug sein Zielfeld erreicht',
          'Ein Spieler gewinnt auch, wenn der Gegner keine gültigen Züge mehr zur Verfügung hat'
        ]
      }
    ],
    
    validMoveTitle: 'Gültiger Zug',
    invalidMoveTitle: 'Ungültiger Zug',
    
    downloadTitle: 'Jetzt Herunterladen',
  },

  /* -------------------- NEW: MOBILE APPLICATIONS PAGE STRINGS (DE) -------------------- */
  mobileApplicationsPage: {
    heroTitle: 'LoKI Bot',
    heroSubtitle: 'Support Chatbot für Lern-Fair',
    heroTech: 'React Native & OpenAI',
    heroImageAlt: 'LoKI Bot Mobile Anwendungs-Mockup',
    
    tabOverview: 'Übersicht',
    tabFeatures: 'Features',
    tabDevelopment: 'Entwicklungsprozess',
    tabTesting: 'User Testing',
    
    overviewTitle: 'Projektübersicht',
    overviewParagraphs: [
      'Der LoKI Bot ist ein Support-Chatbot, der für Lern-Fair entwickelt wurde, um Schülern und Helfern eine schnelle und intuitive Möglichkeit zu bieten, Fragen zu stellen, Termine zu vereinbaren und Unterstützung zu erhalten.',
      'Die mobile Anwendung kombiniert moderne Technologien wie React Native für das Frontend und Node.js für das Backend mit der leistungsstarken OpenAI API, um ein intelligentes Chatbot-Erlebnis zu bieten, das auf die spezifischen Bedürfnisse der Bildungsplattform zugeschnitten ist.',
      'Das Projekt zeigt meinen Fokus auf benutzerfreundliche, zugängliche und innovative Lösungen im Bildungsbereich.'
    ],
    sideMenuImageAlt: 'LoKI Bot Seitenmenü-Interface',
    
    techStackTitle: 'Technologie Stack',
    techStack: [
      'React Native',
      'OpenAI API',
      'Node.js',
      'Express',
      'Expo'
    ],
    
    featuresTitle: 'Features',
    features: [
      {
        title: 'Text-basierter Chatbot',
        description: 'Der Kern der Anwendung ist ein intelligenter Chatbot, der auf Fragen von Schülern und Helfern antworten kann. Er ist auf die spezifischen Anwendungsfälle von Lern-Fair trainiert und liefert relevante Informationen und Unterstützung.'
      },
      {
        title: 'Support-Ticket System',
        description: 'Wenn der Chatbot eine Anfrage nicht beantworten kann, können Benutzer ein Support-Ticket erstellen, das automatisch an einen menschlichen Mitarbeiter weitergeleitet wird.',
        images: [
          {
            src: '/MobileApplications/SupportTicket1.png',
            alt: 'Support-Ticket Erstellung',
            caption: 'Support-Ticket Erstellung'
          },
          {
            src: '/MobileApplications/SupportTicket2.png',
            alt: 'Support-Ticket Rückmeldung',
            caption: 'Support-Ticket Rückmeldung'
          }
        ]
      },
      {
        title: 'Lernpaar-Kalender',
        description: 'Ein integrierter Kalender ermöglicht es Benutzern, Termine für Lerneinheiten zu planen, zu bestätigen oder abzusagen - direkt über den Chatbot.',
        images: [
          {
            src: '/MobileApplications/CalendarFeature.png',
            alt: 'Lernpaar-Kalender Feature',
            caption: 'Interaktiver Kalender zur Terminverwaltung'
          }
        ]
      },
      {
        title: 'Audio-Nachrichten',
        description: 'Benutzer können Audio-Nachrichten aufzeichnen, die automatisch transkribiert und vom Chatbot verarbeitet werden - eine praktische Alternative zur Texteingabe.'
      },
      {
        title: 'Nachrichteninteraktionen',
        description: 'Ein Dropdown-Menü für Nachrichten ermöglicht verschiedene Aktionen wie Bearbeiten, Löschen oder Kopieren von Texten.'
      }
    ],
    
    developmentTitle: 'Entwicklungsprozess',
    agileTitle: 'Agiles Vorgehen',
    agileDescription: 'Das Projekt wurde in drei Sprints mit einem agilen Ansatz umgesetzt, um eine kontinuierliche Verbesserung und Anpassung zu ermöglichen. Ich habe GitLab für das Task-Management und die Versionskontrolle verwendet.',
    
    sprints: [
      {
        title: 'Sprint 1 - Setup',
        tasks: [
          'Einrichtung der Entwicklungsumgebung',
          'Backend-Grundstruktur mit Node.js',
          'Frontend-Grundgerüst mit React Native',
          'Erste OpenAI API-Integration'
        ]
      },
      {
        title: 'Sprint 2 - Integration',
        tasks: [
          'Chat-Interface Implementierung',
          'Kalender-Komponente für Lernpaare',
          'Support-Ticket System',
          'Audio-Transkription'
        ]
      },
      {
        title: 'Sprint 3 - Testing & Deployment',
        tasks: [
          'Usability Testing',
          'Bugfixes und Optimierungen',
          'UI-Verbesserungen',
          'Vorbereitung für Deployment'
        ]
      }
    ],
    
    epicsTitle: 'Epics und User Stories',
    epicsDescription: 'Die Entwicklung wurde in verschiedene Epics unterteilt, die jeweils spezifische Funktionalitäten und User Stories abdeckten:',
    epics: [
      'Chatbot-Entwicklung und Integration',
      'Benutzeroberfläche und User Experience',
      'Chatbot-Training für Lernfair-Anwendungsfälle',
      'Kommunikation, Konnektivität und Qualitätssicherung'
    ],
    
    testingTitle: 'User Testing',
    methodologyTitle: 'Methodik',
    methodologyDescription: 'Ich habe eine Kombination aus Usability Testing und Contextual Inquiry angewendet, bei der Testpersonen in eine realitätsnahe Nutzungssituation versetzt wurden. Ziel war es, die Benutzerfreundlichkeit und Funktionalität des Support-Chatbots zu überprüfen.',
    
    tasksTitle: 'Testaufgaben',
    tasks: [
      'Allgemeine Fragen an den Chatbot stellen',
      'Support-Mitarbeiter anfordern',
      'Nachrichten bearbeiten',
      'Lerntermin vereinbaren',
      'Lerntermin stornieren'
    ],
    
    resultsTitle: 'Ergebnisse',
    resultCategories: [
      {
        title: 'Design und Usability',
        items: [
          'Bessere farbliche Hervorhebung für ausgewählte Kalenderdaten benötigt',
          'Entfernung des schwarzen Rands bei persönlichen Nachrichten',
          'Mehr Abstand links und rechts beim Kalender',
          'Anpassung der Farben für Bestätigungs- und Abbruchknöpfe'
        ]
      },
      {
        title: 'Funktionalität',
        items: [
          'Terminbuchung wurde als gut und sinnvoll bewertet',
          'Chatbot-Antworten sollten gelöscht werden, wenn die zugehörige Anfrage gelöscht wird',
          'Die Möglichkeit, auf eine Antwort zu verweisen, wurde positiv aufgenommen',
          'Verbesserungsbedarf bei der Support-Anfrage-Funktionalität',
          'Text sollte der Tastatur folgen'
        ]
      },
      {
        title: 'Sprachunterstützung',
        items: [
          'Benutzeroberfläche sollte auf Deutsch übersetzt werden'
        ]
      }
    ],
    
    conclusionTitle: 'Fazit',
    conclusionText: 'Das durchgeführte Testing lieferte wertvolle Einblicke in die Benutzerfreundlichkeit und Funktionalität des LoKI Bots. Die gesammelten Rückmeldungen und Beobachtungen dienten als Grundlage für weitere Optimierungen und haben sichergestellt, dass der Chatbot den Bedürfnissen der Nutzer optimal gerecht wird. Die identifizierten Verbesserungsvorschläge wurden für die finale Version umgesetzt.'
  },

  /* -------------------- NEW: PERSONAL HEALTH AI PAGE STRINGS (DE) -------------------- */
  personalHealthAIPage: {
    heroTitle: 'DODONT',
    heroSubtitle: 'Digital Health - Unterstützung für eine bewusste und gesunde Smartphone-Nutzung im Alltag',
    techBadge: 'React Native & AI',
    
    tabSummary: 'Zusammenfassung',
    tabConcept: 'Konzept & Ansatz',
    tabDevelopment: 'Entwicklungsprozess',
    
    summaryTexts: [
      'DODONT ist eine Digital-Health-Anwendung, die Nutzern hilft, eine bewusste und gesunde Beziehung zu ihrem Smartphone zu entwickeln. Das Projekt adressiert die wachsende Besorgnis über übermäßige Bildschirmzeit und deren negative Auswirkungen auf die psychische Gesundheit.',
      'Durch die Kombination von verhaltenspsychologischen Erkenntnissen mit moderner Technologie bietet DODONT personalisierte Unterstützung für Nutzer, die die Kontrolle über ihre digitalen Gewohnheiten zurückgewinnen möchten, ohne sich komplett von der digitalen Welt abzukoppeln.'
    ],
    
    conceptTexts: [
      'Das Konzept hinter DODONT basiert auf Verhaltenspsychologie und nutzerorientiertem Design. Wir haben erkannt, dass die Zielgruppe nicht durch demografische Merkmale, sondern durch Verhalten definiert wird - jeder, der sich dabei ertappt, unbewusst zum Handy zu greifen, kann von unserer Lösung profitieren.',
      'Unser Ansatz konzentriert sich auf Bewusstsein statt Einschränkung. Anstatt Apps zu blockieren oder strenge Limits zu setzen, hilft DODONT den Nutzern, ihre Nutzungsmuster zu verstehen und informierte Entscheidungen über ihren digitalen Konsum zu treffen.'
    ],
    
    developmentTexts: [
      'Der Entwicklungsprozess folgte einem iterativen Designansatz, beginnend mit umfangreicher Nutzerforschung und Wettbewerbsanalyse. Wir führten Interviews mit potenziellen Nutzern durch, um ihre Schmerzpunkte und Motivationen bezüglich der Smartphone-Nutzung zu verstehen.',
      'Die technische Umsetzung umfasst eine React Native Mobile-Anwendung mit einem ansprechenden Onboarding-Erlebnis, ergänzt durch eine Landing Page, die die Mission und Werte des Projekts effektiv kommuniziert.'
    ],
    
    problemTitle: 'Was Sie wissen sollten',
    sourceLink: 'Zur Studie',
    
    statistics: [
      {
        chartImage: '/PersonalHealthXAI/bar-chart1.png',
        title: 'Wachstum der Unterhaltungs-Bildschirmzeit',
        description: 'Zwischen 2019 und 2022 stieg die Bildschirmzeit für Unterhaltung bei Jugendlichen (13-19 Jahre) um über eine Stunde und erreichte 8 Stunden und 39 Minuten pro Tag.',
        sourceLink: 'https://www.commonsensemedia.org/sites/default/files/research/report/8-18-census-integrated-report-final-web_0.pdf'
      },
      {
        chartImage: '/PersonalHealthXAI/bar-chart2.png',
        title: 'Smartphone-Nutzung nach Altersgruppen',
        description: 'Jüngere Personen im Alter von 18-24 Jahren überprüfen ihr Smartphone signifikant eher direkt nach dem Aufwachen (62%) und nutzen Beruhigungs-Apps (50%) im Vergleich zu älteren Altersgruppen.',
        sourceLink: 'https://www.deloitte.com/de/de/Industries/tmt/research/smartphone-nutzung-2024.html'
      },
      {
        chartImage: '/PersonalHealthXAI/bar-chart3.png',
        title: 'Negative Auswirkungen der Smartphone-Nutzung',
        description: 'Fast die Hälfte der jungen Erwachsenen (48%) berichtet, dass sie durch die Smartphone-Nutzung später als beabsichtigt schlafen, wobei sich viele auch abgelenkt fühlen (40%) und gezwungen sehen, ihre Geräte häufig zu überprüfen (55%).',
        sourceLink: 'https://www.deloitte.com/de/de/Industries/tmt/research/smartphone-nutzung-2024.html'
      }
    ],
    
    audienceTitle: 'Verhaltensbasierte Zielgruppe',
    audienceDescription: 'Heutzutage kann jeder von Smartphone-Übernutzung betroffen sein – sei es beim Pendeln im Zug oder in anderen öffentlichen Verkehrsmitteln. Die allgegenwärtige Nutzung von Smartphones macht es leicht, unbewusst mehr Zeit am Bildschirm zu verbringen.',
    audienceImageAlt: 'Menschen im Zug mit Smartphones',
    
    topicsTitle: 'Digitales Wohlbefinden verstehen',
    topicsSubtitle: 'Erkunde die wichtigsten Aspekte, wie Smartphone-Nutzung unseren Alltag und unser Wohlbefinden beeinflusst',
    
    topicItems: [
      {
        image: '/PersonalHealthXAI/bed.png',
        title: 'Schlafstörung & Bildschirmzeit',
        description: 'Übermäßige Smartphone-Nutzung vor dem Schlafengehen stört die natürlichen Schlafmuster. Das blaue Licht von Bildschirmen beeinträchtigt die Melatoninproduktion und erschwert das Einschlafen sowie die Schlafqualität.'
      },
      {
        image: '/PersonalHealthXAI/overload.png',
        title: 'Digitale Überlastung & Mentale Erschöpfung',
        description: 'Die ständige Konfrontation mit Benachrichtigungen und digitalen Inhalten führt zu kognitiver Überlastung. Dies resultiert in mentaler Erschöpfung, reduzierter Konzentration und erhöhtem Stresslevel im Tagesverlauf.'
      },
      {
        image: '/PersonalHealthXAI/parent.png',
        title: 'Familiendynamik & Bildschirmzeit',
        description: 'Die Balance zwischen Familienzeit und Geräte-Nutzung ist zu einer modernen Herausforderung geworden. Eltern kämpfen damit, gesunde Grenzen zu setzen, während sie ihre eigenen digitalen Gewohnheiten managen und für ihre Kinder präsent sein wollen.'
      },
      {
        image: '/PersonalHealthXAI/bench.png',
        title: 'Soziale Verbindung im digitalen Zeitalter',
        description: 'Obwohl digital verbunden, fühlen sich viele Menschen zunehmend isoliert. Physische Anwesenheit garantiert keine echte Verbindung, wenn alle in ihre Geräte vertieft sind – ein Paradox des Zusammenseins und doch Alleinseins.'
      }
    ],
    
    onboardingTitle: 'Interaktives Onboarding-Erlebnis',
    onboardingDescription: 'Probiere unseren Onboarding-Prototyp aus - eine ansprechende Einführung, die Nutzer durch ein interaktives Quiz über digitales Wohlbefinden aufklärt',
    
    onboardingScreens: {
      welcome: {
        title: 'Willkommen',
        text1: 'Wir sind hier, um dich bei deiner Reise zu einem ausgeglichenen digitalen Leben zu unterstützen.',
        text2: 'Übernimm die Kontrolle über deine Social Media Gewohnheiten und gewinn deine Zeit zurück.',
        button: "Los geht's"
      },
      q1: {
        question: 'Ab wie vielen Stunden freizeitliche Bildschirm-Nutzung die Woche zählt man als süchtig?',
        options: ['30 Stunden', '35 Stunden', '40 Stunden', '45 Stunden']
      },
      q2: {
        question: 'Wie viele Menschen hatten schonmal negative Folgen durch Smartphone Nutzung?',
        options: ['23 Prozent', '35 Prozent', '43 Prozent', '56 Prozent']
      },
      q3: {
        question: 'Ein durchschnittlicher Nutzer in Deutschland entsperrt sein Handy alle ...',
        options: ['18 Minuten', '24 Minuten', '27 Minuten', '33 Minuten']
      },
      results: {
        title: 'Deine Antworten',
        q1Label: 'Frage 1: Schwelle zur Bildschirmsucht',
        q2Label: 'Frage 2: Negative Folgen',
        q3Label: 'Frage 3: Durchschnittliche Entsperrhäufigkeit',
        yourAnswer: 'Deine Antwort:',
        correctAnswer: 'Richtige Antwort:',
        q1Correct: '35 Stunden',
        q2Correct: '43 Prozent',
        q3Correct: '18 Minuten',
        noAnswer: 'Keine Auswahl',
        restartBtn: 'Nochmal'
      },
      timeInput: {
        question: 'Wie viele Stunden verbringst du täglich auf deinem Handy?',
        unit: 'Stunden'
      },
      visualization: {
        subtitle: 'Gemessen an deiner Angabe würdest du',
        yearsLabel: 'Jahre',
        description: 'deines Lebens am Handy verbringen',
        lifeLegend: 'Leben',
        socialMediaLegend: 'Social Media'
      },
      continueBtn: 'Weiter'
    }
  },

  /* -------------------- NEW: PROJECT MODULE WEB PAGE STRINGS (DE) -------------------- */
  projectModuleWebPage: {
    hero: {
      backgroundImage: '/ProjectModuleWeb/delphi-bg.png',
      heroImage: '/ProjectModuleWeb/delphi-figure.png',
      title: 'Delphi',
      subtitle: 'Dein persönlicher Studienführer',
      tech: 'React-Projekt',
      figureAlt: 'Delphi Funko-Style Figur'
    },
    tabs: {
      summary: 'Zusammenfassung',
      concept: 'Konzept & Technischer Ansatz',
      challenges: 'Herausforderungen & Erkenntnisse'
    },
    summaryText: [
      "Dieses Projekt konzentriert sich auf die Erstellung einer digitalen Plattform, die die Lücke zwischen Studierenden und Studienberatung schließt. Durch nutzerorientierte Interviews und strukturierte Erkenntnisse möchten wir personalisierte Lösungen für Bildungsentscheidungen bieten.",
      "Das Scope-Bild verdeutlicht die Komplexität des Projekts und zeigt Kernlieferungen wie Landingpage, Profil-/Hilfesektion und KI-gestützten Chat. Jede Komponente stellte einzigartige technische und gestalterische Herausforderungen dar, doch der iterative Ansatz gewährleistete die Übereinstimmung mit den Nutzerbedürfnissen."
    ],
    conceptText: [
      "Das Konzept basiert auf drei Säulen: Einfachheit, Zuverlässigkeit und Unterstützung. Diese Prinzipien sorgen dafür, dass die Plattform intuitiv, vertrauenswürdig und benutzerfreundlich bleibt. Die technische Grundlage umfasst interaktive Funktionen wie ein KI-gestütztes Chatsystem.",
      "Das hexagonale Diagramm im Bild stellt die Schlüsselwerte des Projekts visuell dar und betont ihre vernetzte Natur sowie den ganzheitlichen Ansatz zur Lösung studentischer Herausforderungen."
    ],
    challengesText: [
      "Eine der größten Hürden war, die Benutzeroberfläche einfach zu halten und gleichzeitig vielfältige Funktionen zu ermöglichen. Die Integration von Feedback in iterative Designzyklen half dabei, sowohl Ästhetik als auch Benutzerfreundlichkeit zu verfeinern.",
      "Das Bild veranschaulicht eine wichtige Erkenntnis sowie die Kernphilosophie des Projekts: das tiefe Verständnis der Nutzerbedürfnisse. Es spiegelt den grundlegenden Glauben wider, dass sinnvolle Produkte und Dienstleistungen aus Empathie und Einsicht in Nutzererfahrungen entstehen."
    ],
    tabImages: {
      summary: '/ProjectModuleWeb/summary_w.png',
      concept: '/ProjectModuleWeb/concept_w.png',
      challenges: '/ProjectModuleWeb/challenges_w.png'
    },
    process: {
      title: 'Prozess',
      phases: [
        {
          title: 'Phase 1 – Recherche',
          content: "In der ersten Phase konzentrierten wir uns darauf, die Kernzielgruppe mittels Stakeholder-Mapping und Interviewvorbereitung zu identifizieren. Wichtige Aufgaben umfassten die Erstellung einer umfassenden Stakeholder-Übersicht, die Vorbereitung eines Interviewleitfadens für verschiedene Studierendengruppen und die Durchführung von Desk Research zur Analyse bestehender Daten zu Herausforderungen bei Bildungsentscheidungen. Die Recherche machte häufige Probleme wie unzureichende Orientierung und fehlende strukturierte Informationen deutlich, die die Grundlage für die folgenden Phasen bildeten.",
          pdf: '/ProjectModuleWeb/phase1.pdf'
        },
        {
          title: 'Phase 2 – Synthese',
          content: "Während dieser Phase synthetisierten wir die Interviewdaten und Desk-Research-Ergebnisse zu umsetzbaren Erkenntnissen. Zu den Schlüsselaufgaben gehörten die Kategorisierung der Daten, die Erstellung von Personas zur Repräsentation unterschiedlicher Nutzergruppen sowie das Erstellen eines Konzeptdokuments zur Lösung identifizierter Schmerzpunkte. Diese Phase betonte die Notwendigkeit einer personalisierten und intuitiven Lösung, die die Lücke zwischen theoretischem Wissen und praktischer Anwendung schließt.",
          pdf: '/ProjectModuleWeb/phase2.pdf'
        },
        {
          title: 'Phase 3 – Ideation',
          content: "Die dritte Phase konzentrierte sich auf die Generierung innovativer Ideen und die Gestaltung erster Prototypen. Aufgaben umfassten Brainstorming-Sitzungen mit dem 'How Might We'-Ansatz, die Entwicklung von Flussdiagrammen für Nutzerinteraktionspfade und das Skizzieren von Pre-Wireframe-Entwürfen für wichtige Bildschirme. Schwerpunkt war die Übersetzung der Forschungserkenntnisse in eine funktionale und visuell ansprechende Benutzeroberfläche, die den Nutzerbedarf in den Mittelpunkt stellt.",
          pdf: '/ProjectModuleWeb/phase3.pdf'
        },
        {
          title: 'Phase 4 – Prototyping',
          content: "In der letzten Phase entwickelten wir einen High-Fidelity-Prototyp und führten iterative Tests durch. Zu den Hauptaktivitäten gehörten die Integration von Feedback aus Usability-Tests, die Umsetzung von Designverfeinerungen und die Validierung des Prototyps mithilfe von MeCUE-Bewertungsmetriken. Das Ergebnis war ein ausgefeiltes, benutzertestetes Produkt, das den Projektzielen entspricht und eine nahtlose Nutzererfahrung gewährleistet.",
          pdf: '/ProjectModuleWeb/phase4.pdf'
        }
      ]
    }
  }
};
